<template>
  <div class="leftMenu">
      <div class="side-menu">
          <div class="side-menu-top">
              <button type="button" class="side-close" @click="closeMenu()">
                  <img src="@/assets/images/ico_close.png">
              </button>
          </div>
          <div class="side-category">
              <div class="category-wrap">
                  <h3 class="category-title">드시모네</h3>
                  <div class="category-content">
                      <p @click="clickLink('/goods/catalog?code=000100010002')">온가족</p>
                      <p @click="clickLink('/goods/catalog?code=000100010004')">키즈(13세 이하)</p>
                      <p @click="clickLink('/goods/catalog?code=000100010005')">베이비(24개월 이하)</p>
                      <p v-if="store.isCh" @click="clickLink('/goods/catalog?code=000100100004')">해외전용</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">오투부스터</h3>
                  <div class="category-content">
                      <p @click="clickLink('/goods/catalog?code=00010022')">오투부스터</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">김석진LAB</h3>
                  <div class="category-content">
                      <p @click="goKimLab()" v-if="false">브랜드소개</p>
                      <p @click="clickLink('/goods/catalog?code=000100200001')">김석진LAB</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">또박케어LAB</h3>
                  <div class="category-content">
                    <p @click="clickLink('/goods/catalog?code=000100200002')">또박케어LAB</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">정기구독</h3>
                  <div class="category-content">
                      <p @click="clickLink('/goods/catalog?code=00010023')">정기구독</p>
                  </div>
              </div>
              <div class="category-wrap" v-if="false">
                  <h3 class="category-title">분석 서비스</h3>
                  <div class="category-content">
                      <p @click="clickLink('/mybiome')">장내세균분석 서비스</p>
                      <p v-if="false" @click="clickLink('/page/index?tpl=main%2Fsub15.html')">유전자분석 서비스</p>
                  </div>
              </div>
              <div class="category-wrap" v-if="false">
                  <h3 class="category-title">프리미엄 마스크</h3>
                  <div class="category-content">
                      <p @click="clickLink('/goods/catalog?code=0019')">프리미엄 마스크</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">브랜드</h3>
                  <div class="category-content">
                      <p @click="clickLink('/brand')">브랜드</p>
                  </div>
              </div>
              <div v-if="false" class="category-wrap">
                  <h3 class="category-title link" @click="clickLink('/goods/catalog?code=00010006')">코스메틱바유</h3>
              </div>
              <div v-if="false" class="category-wrap">
                  <h3 class="category-title link" @click="clickLink('/event/gift')">선물하기</h3>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">매거진</h3>
                  <div class="category-content">
                      <p @click="clickLink('/magazine')">매거진</p>
                      <p @click="clickLink('/media')">미디어</p>
                      <p v-if="false" @click="clickLink('/desimone')">드시모네 개발스토리</p>
                      <p v-if="false" @click="clickLink('/probiotics')">명품 프로바이오틱스란?</p>
                      <p @click="clickLink('/review/reviewIndex?tab=ALL&pageNum=1&orderBy=score&keyword=')">구매후기</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">체험팩 신청하기</h3>
                  <div class="category-content">
                      <p @click="goSample()">체험팩 신청하기</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">이벤트/혜택</h3>
                  <div class="category-content">
                      <p @click="clickEvent()">이벤트/혜택</p>
                  </div>
              </div>
              <div class="category-wrap">
                  <h3 class="category-title">고객센터</h3>
                  <div class="category-content">
                      <p @click="clickLink('/faq')">자주하는 질문</p>
                      <p @click="clickQna()">1:1 문의</p>
                      <p @click="clickLink('/noticeList')">공지사항</p>
                      <p v-if="false" @click="clickLink('/agencyList')">오프라인 판매처</p>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script setup lang="ts">
import { getBio11Url } from '@/utils/common';

const store = useMainStore();
const authStore = useAuthStore();
const router = useRouter();

const checkUrlList = [
  '/goods/catalog',
  '/event/gift',
  '/review',
  '/magazine',
  '/media',
  '/desimone',
  '/probiotics',
  '/mybiome',
  '/halfttobak',
  '/agencyList',
  '/faq',
  '/noticeList',
  '/brand',
];

const userName = ref('');

onMounted(async () => {
  const { error, data } = await getMyInfo();
  if (data) {
      userName.value = data.username;
  }

  const store = useMainStore();
  const isCh = await getCh();
  store.updateCh(isCh);
});

const closeMenu = (): void => {
  const html = document.querySelector('html') as HTMLElement | null;
  const leftMenu = document.querySelector('.leftMenu') as HTMLElement | null;
  
  if (html && leftMenu) {
    leftMenu.classList.remove('show');
    html.style.overflow = "";
  }
};

const goSample = (): void => {
  closeMenu();
  navigateTo('/goods/catalog?code=0015');
};

const clickLink = (url: string): void => {
  if (checkUrlList.some(item => url.startsWith(item))) {
    closeMenu();
    navigateTo(url);
  } else {
    navigateTo(`${getBio11Url}${url}`, { external: true });
  }
};

const clickEvent = () => {
  router.push({ name: 'storeEvent' });
  closeMenu();
};

// 1:1 문의
const clickQna = () => {
  if (authStore.isLogin) {
    navigateTo('/mypage/qna');
  } else {
    showLoginPage('/mypage/qna');
  }
  closeMenu();
};

// 또박케어LAB 이동
const goKimLab = () => {
  router.push({ name: 'kimLab'} );
  closeMenu();
};
</script>

<style lang="scss" scoped>
.leftMenu {
    position: fixed;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100vh;
    background: var(--hecto-white);
    z-index: 50;
    overflow-y: scroll;
    transition: left 0.4s ease;
    &.show{
        left: 0;
    }
}
.side-menu {
    position: relative;
    padding: 3rem 5rem 23rem;
}
.side-menu-top{
    margin:0 -5rem 2rem;
    padding:0 3.5rem;
    text-align:right;
}
.side-close > img {
    width: 6rem;
    height: 6rem;
}
.side-name{
    display: inline-flex;
    align-items: center;
    font-size: var(--hecto-font-40);
    color: var(--hecto-black);
    font-weight: bold;
    text-decoration: none;
    letter-spacing: -0.1em;
}
.side-name > img{
    width: 1.5rem;
    height: 2.3rem;
    margin-left: 2rem;
}
.side-top {
    padding: 2rem 0 5rem;
    border-bottom: 1px solid #ececec;
}
.side-top ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
}
.side-top ul li {
    flex: 1;
    letter-spacing: -0.1em;
    text-align: center;
    font-size: var(--hecto-font-28);
    border: 1px solid #edf1f5;
    border-radius: 2rem;
    background-color: #f6f9fc;
}
.side-top ul li + li {
    margin-left: 2rem;
}
.side-top ul li.active {
    color: #aaa;
    border: solid 2px #3a9df4;
}
.side-top ul li a {
    text-decoration: none;
    color: var(--hecto-black);
}
.side-top ul li img {
    width: 10rem;
    height: 10rem;
}
.side-top ul li p {
    margin: 1rem 0 1.5rem;
}

.side-category {
    margin-top: 0;
    border-top:1px solid #ececec;
}
.category-wrap {
    border-bottom: 1px solid #ececec;
}
.category-wrap .category-title {
    font-size: var(--hecto-font-32);
    font-weight: bold;
    letter-spacing: -0.1em;
    margin: 0;
    padding: 5rem 0;
    position: relative;
}
/* .category-wrap .category-title::after {
    content: '';
    position: absolute;
    top: 6rem;
    right:0;
    width: 2.7rem;
    height: 1.6rem;
    background: url(@/assets/images/ico_menu_arrow.png) 100% center / 2.7rem 1.6rem no-repeat;
    transition: all 0.3s ease;
}
.category-wrap .category-title.link::after {
    transform: rotate(-90deg);
}
.category-wrap.on .category-title::after {
    transform: rotate(-180deg);
} */
.category-content {
    padding-left: 2rem;
    overflow: hidden;
    transition: all 0.5s ease;
}
.category-content p {
    color: #999;
    font-size: var(--hecto-font-28);
    letter-spacing: -0.1em;
    margin-bottom: 3rem;
    font-weight: normal;
}

.side-service {
    margin-top: 5rem;
}
.service-title {
    font-size: var(--hecto-font-32);
    font-weight: bold;
    letter-spacing: -0.1em;
    margin: 0;
    padding: 2rem 0 3rem;
}
.service-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
}
.service-list li {
    width: 50%;
    margin-bottom: 3rem;
}
.service-list li a {
    font-size: var(--hecto-font-28);
    letter-spacing: -0.1em;
    color: #999;
    text-decoration: none;
    padding: 1rem 0;
    display: inline-block;
}
.alarmLink{
    color: #585a5a !important;
    background-image: linear-gradient(to bottom, #fff 70%, #b1eef1 70%);
    white-space: nowrap;
}
</style>